module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-card"
  }, [_c('FormHeader', {
    attrs: {
      "title": _vm.formHeaderTitle,
      "datalayerName": _vm.datalayerName
    }
  }), _vm._v(" "), _c('FormSupporterDetails', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "messageId": _vm.messageId,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource,
      "iveCampaignId": _vm.iveCampaignId,
      "requirePhone": _vm.requirePhone,
      "thankYouUrl": _vm.thankYouUrl,
      "privacyPolicyUrl": _vm.privacyPolicyUrl,
      "title": _vm.formSupporterDetailsTitle,
      "subtitle": _vm.formSupporterDetailsSubtitle
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-001bd0f3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/ActionForm.vue
// module id = 746
// module chunks = 0